<app-app-layout>
  <div class="mobile-payment-container">
    <!-- User Info Card -->
    <div class="user-info-section">
      <app-user-info-card
        [email]="subscriberDetail.email"
        [name]="subscriberDetail.name"
      >
      </app-user-info-card>
    </div>

    <!-- Country Selection -->
    <div class="region-section" *ngIf="defaultCountryCode === 'india'">
      <div class="region-card">
        <h3 class="section-title">Select Your Payment Region</h3>
        <p class="section-subtitle">
          Choose your billing country to see applicable pricing
        </p>

        <div class="region-toggle-group">
          <mat-button-toggle-group
            [hideSingleSelectionIndicator]="true"
            [(ngModel)]="selectedCountryCode"
            (change)="changeCountryEvent()"
            class="region-toggles"
            aria-label="Payment Region"
          >
            <mat-button-toggle value="india" class="region-toggle">
              <div class="toggle-content">
                <mat-icon>location_on</mat-icon>
                <div>
                  <div>India</div>
                  <div>(₹ INR)</div>
                </div>
                <mat-icon
                  class="check-icon"
                  *ngIf="selectedCountryCode === 'india'"
                  >check_circle</mat-icon
                >
              </div>
            </mat-button-toggle>

            <mat-button-toggle value="international" class="region-toggle">
              <div class="toggle-content">
                <mat-icon>language</mat-icon>
                <div>
                  <div>International</div>
                  <div>($ USD)</div>
                </div>
                <mat-icon
                  class="check-icon"
                  *ngIf="selectedCountryCode === 'international'"
                  >check_circle</mat-icon
                >
              </div>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>

    <!-- Gym Branch Selection -->
    <div class="branch-section">
      <app-gym-branch-selection-card
        [selectedBranchId]="selectedBranchId"
        (branchSelected)="onBranchSelected($event)"
      ></app-gym-branch-selection-card>
    </div>
    <!-- Progress Bar -->
    <!-- Plans Section with Tabs -->
    <div class="plans-section">
      <div class="plans-header">
        <h2 class="plans-title">Choose Your Plan</h2>
        <p class="plans-subtitle">
          Premium gym management plans with simple, transparent pricing
        </p>

        <!-- GST Note -->
        <div
          class="gst-info-note"
          *ngIf="!isInternationalPayment && isGstFeatureEnabled"
        >
          <strong>Note:</strong> All amounts exclude GST. Input Tax Credit (ITC)
          can be claimed by GST-registered businesses.
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="!plans || plans.length === 0" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="loading-text">Loading subscription plans...</p>
      </div>

      <!-- Duration Tabs -->
      <mat-tab-group
        *ngIf="plans && plans.length > 0"
        class="duration-tabs"
        animationDuration="300ms"
      >
        <mat-tab
          *ngFor="let groupedPlan of plans"
          [label]="groupedPlan.name"
          class="duration-tab"
        >
          <div class="tab-content">
            <div class="plans-grid">
              <div
                *ngFor="let plan of groupedPlan.plans"
                class="plan-card"
                [class.plan-card--selected]="isPlanSelected(plan)"
                [class.plan-card--popular]="isBestValuePlan(plan)"
                [class.plan-card--pro]="plan.planType === 'pro'"
                (click)="selectPlan(plan)"
              >
                <!-- Popular Badge -->
                <div class="popular-badge" *ngIf="isBestValuePlan(plan)">
                  <mat-icon>star</mat-icon>
                  <span>Most Popular</span>
                </div>

                <!-- Plan Name + Price Section -->
                <div class="plan-header-section">
                  <div class="plan-name-section">
                    <h3 class="plan-name">{{ plan.planLabel }}</h3>
                    <div class="discount-row" *ngIf="hasDiscount(plan)">
                      <span class="original-price">{{
                        formatCurrency(plan.originalAmount / plan.months)
                      }}</span>
                      <span class="discount-badge">
                        Save {{ formatCurrency(getSavingsAmount(plan) / plan.months) }}/mo
                      </span>
                    </div>
                    <div class="plan-price">
                      <span class="amount">{{
                        formatCurrency(plan.amount / plan.months)
                      }}</span>
                      <span class="period">/ month</span>
                    </div>
                    <div
                      class="gst-note"
                      *ngIf="!isInternationalPayment && isGstFeatureEnabled"
                    >
                      + {{ plan.gstPercentage * 100 }}% GST
                    </div>
                  </div>
                </div>

                <!-- Usage Limit Section -->
                <div class="usage-limit-section">
                  <div class="usage-limit-item">
                    <mat-icon class="usage-icon">group</mat-icon>
                    <span class="usage-label">{{
                      plan.usageLimit.members.label
                    }}</span>
                  </div>
                  <div class="usage-limit-item">
                    <mat-icon class="usage-icon">person</mat-icon>
                    <span class="usage-label">{{
                      plan.usageLimit.staff.label
                    }}</span>
                  </div>
                </div>

                <!-- Feature List Section -->
                <div class="feature-list-section">
                  <div
                    *ngFor="let feature of plan.featureList"
                    class="feature-item"
                  >
                    <mat-icon class="feature-icon">check_circle</mat-icon>
                    <span class="feature-text">{{ feature }}</span>
                  </div>
                </div>

                <!-- Select Button -->
                <button
                  mat-raised-button
                  class="select-button"
                  [class.select-button--selected]="isPlanSelected(plan)"
                >
                  <mat-icon *ngIf="isPlanSelected(plan)">check</mat-icon>
                  <span>{{
                    isPlanSelected(plan) ? "Selected" : "Select Plan"
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <!-- Sticky Bottom Payment Bar -->
    <div class="sticky-payment-bar" *ngIf="selectedPlan && selectedPlan.amount">
      <div class="payment-summary">
        <div class="plan-info">
          <span class="plan-name">{{ selectedPlan.planLabel }}</span>
          <span class="plan-duration">({{ selectedPlan.months }}M)</span>
        </div>
        <div class="usage-info">
          <span class="usage-item">{{
            selectedPlan.usageLimit.members.label
          }}</span>
          <span class="usage-separator">•</span>
          <span class="usage-item">{{
            selectedPlan.usageLimit.staff.label
          }}</span>
        </div>
      </div>
      <button
        mat-raised-button
        class="proceed-payment-button"
        (click)="openInvoiceDialog()"
        color="primary"
      >
        <span class="button-text">
          <span class="cta-text">Continue to Billing</span>
                 &nbsp; &nbsp;

          <span class="amount-text" *ngIf="selectedPlan">
            (
            {{ formatCurrency(selectedPlan.amount) }}
            <span *ngIf="!isInternationalPayment && isGstFeatureEnabled">
              + {{ selectedPlan.gstPercentage * 100 }}% GST
            </span>
            )
          </span>
        </span>
      </button>
    </div>
  </div>
</app-app-layout>
